export const CheckIcon = () => {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4008 1.76908L5.37137 9.65761L0.599121 4.96908L2.00076 3.54241L5.37137 6.85388L11.9991 0.342407L13.4008 1.76908Z"
        fill="#D6D6D6"
      />
    </svg>
  );
};

export const CheckIconTask = () => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 6.5L6 10L14 2"
        stroke="gray"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
